import { render, staticRenderFns } from "./DinamicaOutrosFamiliares.vue?vue&type=template&id=edba4b26"
import script from "./DinamicaOutrosFamiliares.vue?vue&type=script&lang=js"
export * from "./DinamicaOutrosFamiliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports